import { render, staticRenderFns } from "./ProgressReport.vue?vue&type=template&id=2331f89a&"
import script from "./ProgressReport.vue?vue&type=script&lang=js&"
export * from "./ProgressReport.vue?vue&type=script&lang=js&"
import style0 from "./ProgressReport.vue?vue&type=style&index=0&id=2331f89a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports